// extracted by mini-css-extract-plugin
export var teamListItem = "team-module--team-list-item--Rzqzf";